<template>
  <div class="formset" :class="{ 'formset--required': required }">
    <p class="formset__label">{{ $props.sectionName }}</p>
    <slot></slot>
    <p v-if="items.length === 0" class="formset__info">Brak elementów</p>
    <el-collapse-transition>
      <p v-if="fieldError" class="formset__error">{{ fieldError }}</p>
    </el-collapse-transition>
    <el-button class="formset__add" type="warning" @click="addItem">
      Dodaj nowy
    </el-button>
  </div>
</template>
<script>
import { clone } from 'lodash'

/** @typedef {Object} ErrorObject
 * @property {string[]} non_field_errors
 */

/** @typedef {Record<string, string>[]} ErrorArray */

export default {
  props: {
    blankObject: Object,
    items: Array,
    /** @type {ErrorObject | ErrorArray} */
    errors: {
      type: Array,
      default: () => []
    },
    sectionName: String,
    required: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    addItem() {
      const newObject = clone(this.blankObject)
      if (!Array.isArray(this.items)) {
        this.$emit('input', [newObject])
      } else {
        this.items.push(newObject)
      }
    }
  },
  computed: {
    fieldError() {
      if(Array.isArray(this.errors) || !Array.isArray(this.errors.non_field_errors)) return ''

      return this.errors.non_field_errors[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.formset {
  &__label {
    .formset--required &::before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
    }
  }

  &__info {
    margin-bottom: 0.5em;
  }

  &__error {
    margin: 0;
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
  }

  &__add {
    margin-top: 15px;
  }
}
</style>
